// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */\n.map-chart[data-v-6657cca4] {\n  padding-top: 24px;\n  height: 457px;\n  text-align: center;\n}\n.map-chart img[data-v-6657cca4] {\n  display: inline-block;\n  max-width: 100%;\n  max-height: 437px;\n}\n.pie-card .pie-stat[data-v-6657cca4] {\n  font-size: 24px;\n}\n@media screen and (max-width: 992px) {\n.map-chart[data-v-6657cca4] {\n    height: auto;\n}\n}", ""]);
// Exports
module.exports = exports;
